import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {Button, Card, Col, Form, Modal, Row} from "react-bootstrap";
import {baseUrl, ipAddress, userName} from "../Univ";
import ERPDataGrid from "../ERPDataGrid";
const initialState = {
    provider_name: "",
    provider_type: "",
    api_url: "",
    api_key: "",
    default_model: "",
    timeout: 60,
    is_default: false,
    is_active: true,
    addedby: userName,
    ip_address: ipAddress
};
const AIProvider = () => {
    const [providers, setProviders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [providerId, setProviderId] = useState(null);
    const [formData, setFormData] = useState(initialState);
    const getProviders = () => {
        setLoading(true);
        axios
            .get(baseUrl + "ai-provider/")
            .then((res) => {
                setProviders(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };
    useEffect(() => {
        getProviders();
    }, []);
    const handleChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData({
            ...formData, [name]: type === "checkbox" ? checked : value
        });
    };
    const resetForm = () => {
        setFormData(initialState);
        setEditMode(false);
        setProviderId(null);
    };
    const saveProvider = () => {
        if (!formData.provider_name) {
            Swal.fire("Validation", "Provider Name is required", "warning");
            return;
        }
        const request = editMode ? axios.put(baseUrl + "ai-provider/" + providerId + "/", formData) : axios.post(baseUrl + "ai-provider/", formData);
        request
            .then(() => {
                Swal.fire({
                    icon: "success",
                    title: editMode ? "Provider Updated" : "Provider Created",
                    timer: 1500,
                    showConfirmButton: false
                });
                getProviders();
                setShow(false);
                resetForm();
            })
            .catch((err) => {
                console.log(err);
                Swal.fire("Error", "Unable to save provider", "error");
            });
    };
    const deleteProvider = (id) => {
        Swal.fire({
            title: "Delete Provider?", text: "This cannot be undone.", icon: "warning", showCancelButton: true
        }).then((result) => {
            if (!result.isConfirmed) return;
            axios
                .delete(baseUrl + "ai-provider/" + id + "/")
                .then(() => {
                    getProviders();
                    Swal.fire("Deleted", "", "success");
                });
        });
    };
    const editProvider = (row) => {
        setEditMode(true);
        setProviderId(row.id);
        setFormData({
            provider_name: row.provider_name || "",
            provider_type: row.provider_type || "",
            api_url: row.api_url || "",
            api_key: row.api_key || "",
            default_model: row.default_model || "",
            timeout: row.timeout || 60,
            is_default: row.is_default,
            is_active: row.is_active,
            addedby: userName,
            ip_address: ipAddress
        });
        setShow(true);
    };
    const columns = [{
        field: "id", headerName: "ID", width: 80
    }, {
        field: "provider_name", headerName: "Provider Name", flex: 1
    }, {
        field: "provider_type", headerName: "Type", width: 130
    }, {
        field: "default_model", headerName: "Default Model", flex: 1
    }, {
        field: "timeout", headerName: "Timeout", width: 110
    }, {
        field: "is_default", headerName: "Default", width: 100, renderCell: (params) => (params.value ? "Yes" : "No")
    }, {
        field: "is_active",
        headerName: "Status",
        width: 100,
        renderCell: (params) => (params.value ? "Active" : "Inactive")
    }, {
        field: "action", headerName: "Action", width: 180, sortable: false, renderCell: (params) => (<>
            <Button
                size="sm"
                variant="warning"
                className="me-2"
                onClick={() => editProvider(params.row)}
            >
                Edit
            </Button>

            <Button
                size="sm"
                variant="danger"
                onClick={() => deleteProvider(params.row.id)}
            >
                Delete
            </Button>
        </>)
    }];
    return (<>

        <Card className="shadow mb-3">

            <Card.Header>

                <Row>

                    <Col>

                        <h5>AI Provider Master</h5>

                    </Col>

                    <Col className="text-end">

                        <Button
                            variant="primary"
                            onClick={() => {
                                resetForm();
                                setShow(true);
                            }}
                        >
                            + Add Provider
                        </Button>

                    </Col>

                </Row>

            </Card.Header>

            <Card.Body>

                <div
                    style={{
                        height: 520, width: "100%"
                    }}
                >

                    <ERPDataGrid
                        rows={providers}
                        columns={columns}
                        loading={loading}
                    />

                </div>

            </Card.Body>

        </Card>

        <Modal
            show={show}
            onHide={() => setShow(false)}
            size="lg"
        >

            <Modal.Header closeButton>

                <Modal.Title>

                    {editMode ? "Edit AI Provider" : "Add AI Provider"}

                </Modal.Title>

            </Modal.Header>

            <Modal.Body>

                <Form>

                    <Row>

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>
                                    Provider Name
                                </Form.Label>

                                <Form.Control
                                    name="provider_name"
                                    value={formData.provider_name}
                                    onChange={handleChange}
                                />

                            </Form.Group>

                        </Col>

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>
                                    Provider Type
                                </Form.Label>

                                <Form.Select
                                    name="provider_type"
                                    value={formData.provider_type}
                                    onChange={handleChange}
                                >

                                    <option value="">
                                        Select
                                    </option>

                                    <option value="Cloud">
                                        Cloud
                                    </option>

                                    <option value="Local">
                                        Local
                                    </option>

                                    <option value="Azure">
                                        Azure
                                    </option>

                                    <option value="AWS">
                                        AWS
                                    </option>

                                    <option value="Private">
                                        Private
                                    </option>

                                </Form.Select>

                            </Form.Group>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={12}>

                            <Form.Group>

                                <Form.Label>
                                    API URL
                                </Form.Label>

                                <Form.Control
                                    name="api_url"
                                    value={formData.api_url}
                                    onChange={handleChange}
                                />

                            </Form.Group>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={12}>

                            <Form.Group>

                                <Form.Label>
                                    API Key
                                </Form.Label>

                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="api_key"
                                    value={formData.api_key}
                                    onChange={handleChange}
                                />

                            </Form.Group>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>
                                    Default Model
                                </Form.Label>

                                <Form.Control
                                    name="default_model"
                                    value={formData.default_model}
                                    onChange={handleChange}
                                />

                            </Form.Group>

                        </Col>

                        <Col md={6}>

                            <Form.Group>

                                <Form.Label>
                                    Timeout (Seconds)
                                </Form.Label>

                                <Form.Control
                                    type="number"
                                    name="timeout"
                                    value={formData.timeout}
                                    onChange={handleChange}
                                />

                            </Form.Group>

                        </Col>

                    </Row>

                    <Row className="mt-3">

                        <Col md={6}>

                            <Form.Check
                                type="checkbox"
                                label="Default Provider"
                                name="is_default"
                                checked={formData.is_default}
                                onChange={handleChange}
                            />

                        </Col>

                        <Col md={6}>

                            <Form.Check
                                type="checkbox"
                                label="Active"
                                name="is_active"
                                checked={formData.is_active}
                                onChange={handleChange}
                            />

                        </Col>

                    </Row>

                </Form>

            </Modal.Body>

            <Modal.Footer>

                <Button
                    variant="secondary"
                    onClick={() => setShow(false)}
                >
                    Close
                </Button>

                <Button
                    variant="success"
                    onClick={saveProvider}
                >
                    Save
                </Button>

            </Modal.Footer>

        </Modal>

    </>);
};
export default AIProvider;